import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { queryInvoiceContent, queryInvoiceType } from '@api/core/dict';
import { queryDeleteAttachment } from '@api/pub/attachment';
import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFile';
import { BackBtn } from '@comm/BackBtn';

const FormItem = Form.Item;
const { Option } = Select;
class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: props.data.type || '0',
      invoiceType: [],
      invoiceContent: [],
      delFiles: [],
    };
  }

  componentDidMount() {
    this.getInvoiceType();
    this.getInvoiceContent();
  }

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          invoiceType: res.data,
        });
      }
    });
  };

  getInvoiceContent = () => {
    queryInvoiceContent().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          invoiceContent: res.data,
        });
      }
    });
  };

  start = e => {
    this.submit(e, null, 'start');
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit, data } = this.props;
    const params = {
      ...data,
      ...this.props.form.getFieldsValue(),
    };
    params.link = params.links;
    delete params.links;
    this.props.form.validateFields(err => {
      if (!err) {
        handSubmit(params);
        if (this.state.delFiles.length > 0) {
          this.state.delFiles.map(item => {
            queryDeleteAttachment({
              uuid: item.uuid,
            }).then(() => {});
            return item;
          });
        }
      }
    });
  };

  /**
   *文件删除
   */
  fileRemove = file => {
    const { delFiles } = this.state;
    delFiles.push(file);
    this.setState({ delFiles });
  };

  handleCompanyChange = (value, option) => {
    this.props.form.setFieldsValue({
      income: option.props.children,
    });
  };

  handleTypeChange = e => {
    this.type = e;
    this.setState({
      type: e,
    });
  };

  render() {
    const dataItem = this.props.data;
    const { isSubmitting } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { type, invoiceType, invoiceContent } = this.state;
    getFieldDecorator('income', { initialValue: dataItem.income });
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
    const ItemLayout2 = {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.start}
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {dataItem.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card title="开票申请">
          <Row>
            <Col span={10}>
              <FormItem label="开票类型" {...ItemLayout}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择开票类型!' }],
                  initialValue: dataItem.uuid ? dataItem.type : '0',
                })(
                  <Select onChange={this.handleTypeChange}>
                    {invoiceType.map(item => (
                      <Option key={item.value}>{item.key}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              <FormItem label="入账公司" {...ItemLayout}>
                {getFieldDecorator('incomeUuid', {
                  rules: [{ required: true, message: '请选择入账公司' }],
                  initialValue: dataItem ? dataItem.incomeUuid : null,
                })(
                  <CompanySearch
                    onChange={this.handleCompanyChange}
                    companyName={dataItem ? dataItem.income : null}
                    companyUuid={dataItem ? dataItem.incomeUuid : null}
                    {...this.props}
                  />,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="购货公司" {...ItemLayout}>
                {getFieldDecorator('company', {
                  rules: [{ required: true, message: '请输入购货公司' }],
                  initialValue: dataItem ? dataItem.company : null,
                })(<Input />)}
              </FormItem>
            </Col>
            <Col span={10}>
              {type === '0' || type === '1' ? (
                <FormItem label="纳税人识别号" {...ItemLayout}>
                  {getFieldDecorator('idCode', {
                    rules: [{ required: true, message: '请输入纳税人识别号!' }],
                    initialValue: dataItem ? dataItem.idCode : null,
                  })(<Input />)}
                </FormItem>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="开票内容" {...ItemLayout}>
                {getFieldDecorator('content', {
                  rules: [{ required: true, message: '请输入开票内容!' }],
                  initialValue: dataItem ? dataItem.content : '',
                })(
                  <Select>
                    {invoiceContent.map(item => (
                      <Option key={item.value}>{item.key}</Option>
                    ))}
                  </Select>,
                )}
              </FormItem>
            </Col>
            <Col span={10}>
              {type === '0' ? (
                <FormItem label="地址及电话" {...ItemLayout}>
                  {getFieldDecorator('links', {
                    rules: [{ required: true, message: '请输入地址及电话!' }],
                    initialValue: dataItem ? dataItem.link : null,
                  })(<Input />)}
                </FormItem>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col span={10}>
              <FormItem label="开票金额" {...ItemLayout}>
                {getFieldDecorator('price', {
                  rules: [
                    {
                      required: true,
                      message: '请输入开票金额!',
                    },
                  ],
                  initialValue: dataItem ? dataItem.price : '',
                })(<InputNumber style={{ width: '100%' }} />)}
              </FormItem>
            </Col>
            <Col span={10}>
              {type === '0' ? (
                <FormItem label="开户行及帐号" {...ItemLayout}>
                  {getFieldDecorator('bankCode', {
                    rules: [{ required: true, message: '请输入开户行及帐号!' }],
                    initialValue: dataItem ? dataItem.bankCode : null,
                  })(<Input />)}
                </FormItem>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="申请附件" labelCol={{ span: 3 }} wrapperCol={{ span: 5 }}>
                {getFieldDecorator('files', {
                  initialValue: dataItem ? dataItem.files : null,
                })(
                  <UploadFile
                    type="ghost"
                    fileList={dataItem.file}
                    style={{ width: '60%' }}
                    onRemove={this.fileRemove}
                    isPreview
                  />,
                )}
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="开票说明" {...ItemLayout2}>
                {getFieldDecorator('reason', {
                  rules: [{ required: true, message: '请输入开票说明!' }],
                  initialValue: dataItem ? dataItem.reason : '',
                })(
                  <Input.TextArea
                    placeholder="请输入本次申请开票的说明"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
            <Col span={20}>
              <FormItem label="开票备注" {...ItemLayout2}>
                {getFieldDecorator('remark', {
                  initialValue: dataItem ? dataItem.remark : '',
                })(
                  <Input.TextArea
                    placeholder="请输入在发票上显示的开票备注信息"
                    type="textarea"
                    autosize={{ minRows: 3, maxRows: 9 }}
                    maxLength={1000}
                  />,
                )}
                <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
      </Form>
    );
  }
}

export default connect(state => ({
  incuInfo: state.incubator_base,
}))(Form.create({})(BaseForm));



// WEBPACK FOOTER //
// ./src/components/finance/invoice/FormBase.js